import { Component } from '@angular/core';

@Component({
  selector: 'kett-menu-bar',
  templateUrl: './menu-bar-form.component.html',
  styleUrls: ['./menu-bar-form.component.scss'],
})
export class MenuFormComponent {
  claimUrls: { [key: string]: string } = {
    th: 'https://ibu-claim.sf-express.com/#/applyClaim?channel=kex&lang=th-TH',
    en: 'https://ibu-claim.sf-express.com/#/applyClaim?channel=kex&lang=en',
    cn: 'https://ibu-claim.sf-express.com/#/applyClaim?channel=kex&lang=zh-CN',
  };
  getClaimUrl(): string {
    let lang = window.location.pathname.split('/')[1] || 'en';
    return this.claimUrls[lang]
  }
}
